import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GamecardDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchGamecardPlans } from "../../../../features/auth/store/gamecardPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Gamecard from "./Gamecard";

const GamecardRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedGamecardPlan, setSelectedGamecardPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { gamecardPlans, loading, error } = useSelector(
    (state: RootState) => state.gamecardPlans
  );

  useEffect(() => {
    const filters: any = {};

    // Only add status filter if it's not empty
    if (statusFilter && statusFilter !== "") {
      filters.status = statusFilter;
    }
    if (searchTerm && searchTerm !== "") {
      filters.search = searchTerm;
    }

    dispatch(fetchGamecardPlans(filters));
  }, [dispatch, statusFilter, searchTerm]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleGamecardPlanClick = (dataPlan: Product) => {
    setSelectedGamecardPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedGamecardPlan(null);
  };

  if (showDetailView && selectedGamecardPlan) {
    return (
      <GamecardDetailView
        gamecardPlan={{
          ...selectedGamecardPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Gamecard
      gamecardPlans={gamecardPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onGamecardPlanClick={handleGamecardPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default GamecardRouter;
